/**
 * Цвет дня по отклонению от нормы калорий.
 *
 * Три состояния: коридор ±10% — это поддержка, по сторонам от него дефицит и
 * профицит. Прежде состояний было четыре — дефицит и профицит делились на две
 * ступени по 15%, — и слабый дефицит визуально сливался с поддержкой.
 *
 * Правило живёт здесь, а не в компонентах: одну и ту же полосу дней рисуют
 * и календарь месяца, и недельная лента в шапке дневника, и включает их один
 * переключатель в настройках. Пока это были две копии, они разъехались бы при
 * первой же правке — и один и тот же день получил бы разные цвета на соседних
 * вкладках.
 *
 * Отдаём цвет, а не класс Tailwind. Классы Tailwind собирает, сканируя
 * исходники, и строку, склеенную из переменной, он не найдёт — стиль просто
 * не попадёт в сборку.
 */

// Цвета взяты у шкал КБЖУ, а не подобраны отдельно: на одном экране рядом
// стоят полоса «Ккал» (#EE998C) и полоса «Клетчатка» (#A6B779), и собственная
// палитра дней с ними спорила. Профицит теперь того же цвета, что калории,
// дефицит — что клетчатка. Меняете цвет шкалы в Diary.vue — меняйте и здесь.
export const KCAL_DAY_COLORS = {
  deficit: '#A6B779',      // калорий меньше нормы больше чем на 10%; цвет шкалы «Клетчатка»
  maintenance: '#e4c9b6',  // в пределах ±10% от нормы
  surplus: '#EE998C',      // калорий больше нормы больше чем на 10%; цвет шкалы «Ккал»
  // Записи есть, а покрасить не по чему: нет нормы или нет калорий за день.
  // Оттенок нейтральный и в легенде не участвует — раньше здесь стоял цвет
  // дефицита, и день без данных выглядел дефицитным. Выключенные цвета сюда
  // не попадают: такой день красится цветом нормы (решение владельца 27.10.2026).
  unknown: '#e8e2d9',
}

const THRESHOLD = 0.1

/** Цвет фона дня или null, если записей нет и красить нечего. */
export function dayBgColor(dateStr, hasEntries, { showKcalColors, kcalNorm, dayKcals }) {
  if (!hasEntries) return null
  // Цветовое кодирование выключено — все дни с записями одним цветом нормы
  if (!showKcalColors) return KCAL_DAY_COLORS.maintenance
  if (!kcalNorm || dayKcals?.[dateStr] == null) return KCAL_DAY_COLORS.unknown
  const ratio = dayKcals[dateStr] / kcalNorm
  if (ratio < 1 - THRESHOLD) return KCAL_DAY_COLORS.deficit
  if (ratio <= 1 + THRESHOLD) return KCAL_DAY_COLORS.maintenance
  return KCAL_DAY_COLORS.surplus
}

export function dayBackground(date, hasEntries, options) {
  const state = options.dayStates?.[date]
  if (state?.complete === false && (hasEntries || typeof state.override === 'boolean')) return {
    backgroundColor: 'var(--day-incomplete-bg)',
    backgroundImage: 'repeating-linear-gradient(135deg, transparent 0 4px, var(--day-incomplete-line) 4px 5.5px, transparent 5.5px 7px)',
  }
  const color = dayBgColor(date, hasEntries, options)
  return color ? { backgroundColor: color } : {}
}
